import Immutable from 'immutable';

const IndividualDevelopmentPlanRecord = Immutable.Record({
  id: undefined,
  studentId: undefined,
  period: undefined,
  learningResult: undefined,
  studentIDPFeedbackSuggestions: undefined,
  lastUpdatedTimeUtc: undefined,
  dosRejectedComment: undefined,
  check: undefined,
});

export default class IndividualDevelopmentPlan extends IndividualDevelopmentPlanRecord { }



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/Idp/model.js